import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=4ca88024&scoped=true"
import script from "./goodList.vue?vue&type=script&lang=js"
export * from "./goodList.vue?vue&type=script&lang=js"
import style0 from "./goodList.vue?vue&type=style&index=0&id=4ca88024&prod&lang=css"
import style1 from "./goodList.vue?vue&type=style&index=1&id=4ca88024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca88024",
  null
  
)

export default component.exports